module.exports = __webpack_public_path__ + "static/img/index_main_footer2.4195f76.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/index_main_footer2.png
// module id = +3SW
// module chunks = 1